export const UPLOAD_ADD_FILES = "UPLOAD_ADD_FILES";
export const UPLOAD_REMOVE_FILE = "UPLOAD_REMOVE_FILE";
export const UPLOAD_UPDATE_FILE_STATUS = "UPLOAD_UPDATE_FILE_STATUS";
export const UPDATE_FILE_IS_SET_VALIDATING = "UPDATE_FILE_IS_SET_VALIDATING";
export const UPLOAD_RESET_FILES = "UPLOAD_RESET_FILES";
export const SET_STEP_INDEX = "SET_STEP_INDEX";
export const UPLOAD_SET_FILE_IS_UPLOADING = "UPLOAD_SET_FILE_IS_UPLOADING";
export const UPLOAD_FILE_UPLOAD_SUCCESS = "UPLOAD_FILE_UPLOAD_SUCCESS";
export const UPLOAD_FILE_UPLOAD_ERROR = "UPLOAD_FILE_UPLOAD_ERROR";
export const UPLOAD_UPDATE_VALIDATION_LOG = "UPLOAD_UPDATE_VALIDATION_LOG";
export const SET_SELECTED_ORGANIZATION = "SET_SELECTED_ORGANIZATION";
